// LoginPage.jsx
import React, { useEffect, useState } from "react";
import {
    App,
    Button,
    Card,
    Checkbox,
    Divider,
    Form,
    Input,
    Typography,
    theme,
    Avatar,
    Space,
    Alert,
    Flex,
} from "antd";
import { MailOutlined, LockOutlined, UserOutlined, ReloadOutlined } from "@ant-design/icons";
import api from "../services/api";
import { useNavigate } from "react-router";
import { useAuth } from "../auth/AuthProvider";
import { useLanguage } from "../providers/LanguageProvider";
import { useDispatch } from "react-redux";
import { setCredentials } from "../store/authSlice";
import LangSelect from "src/layouts/MainLayout/LangSelect";
const { Title, Text, Link } = Typography;

export default function LoginPage({ onLogin }) {
    const { token } = theme.useToken();
    const { t } = useLanguage();
    const [loading, setLoading] = useState(false);
    const messageApi = App.useApp().message;
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState("");
    const [form] = Form.useForm();
    const [error, setError] = useState("");
    const language = useLanguage();
    const activeLang = language.language


    const [loadingResend, setLoadingResend] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("rememberMe") === "true") {
            const rememberedEmail = localStorage.getItem("rememberedEmail");
            form.setFieldsValue({ Email: rememberedEmail, remember: true });
        } else {
            form.setFieldsValue({ Email: "", Password: "" });

        }
    }, []);

    const handleSubmit = async (values) => {

        if (values.remember) {
            localStorage.setItem("rememberMe", "true");
            localStorage.setItem("rememberedEmail", values.Email);
        }


        setErrorMessage("");
        try {
            setLoading(true);
            delete values.remember;

            const response = await api.post("/auth/login", { ...values });
            const token = response?.data?.token;
            const account = response?.data?.account;

            if (!token) {
                throw new Error(t("ERROR_TOKEN_NOT_RECEIVED", "Token alınamadı"));
            }

            localStorage.setItem("token", token);
            if (account) {
                setUser(account);
                dispatch(setCredentials({ token, account }));
            }

            if (account?.FirstName || account?.LastName) {
                messageApi.success(
                    t("LOGIN_WELCOME_BACK", "Tekrar hoş geldin") +
                    " " +
                    (account?.FirstName || "") +
                    " " +
                    (account?.LastName || "")
                );
            } else {
                messageApi.success(t("LOGIN_SUCCESS", "Giriş başarılı"));
            }

            onLogin?.({ email: values.email });
            navigate("/");
        } catch (err) {
            const errorKey = err?.response?.data?.message;
            const errorKeyDetail = err?.response?.data?.details?.error;
            if (errorKeyDetail && errorKeyDetail !== "") {


                if (errorKeyDetail) {
                    messageApi.error(t(errorKeyDetail));
                    setErrorMessage(errorKeyDetail)
                }

            } else {
                messageApi.error(t(t("BACKEND_INTERNAL_ERROR")))
                setErrorMessage(t("BACKEND_INTERNAL_ERROR"));
            }
        } finally {
            setLoading(false);
        }
    };



    const onClickResendConfirmation = async () => {
        setLoadingResend(true);

        try {

        } catch (e) {

        } finally {
            setLoadingResend(false);
        }

    }

    const containerStyle = {
        minHeight: "100svh",
        display: "grid",
        placeItems: "center",
        padding: 24,
        background: (token as any).isDark ? token.colorBgLayout : `linear-gradient(180deg, ${token.colorBgLayout} 0%, #fff 100%)`,
    };

    const cardStyle = {
        width: "100%",
        maxWidth: 440,
        borderRadius: 16,
        boxShadow: token.colorBgElevated === "#fff" ? "0 8px 30px rgba(0,0,0,0.06)" : "0 8px 30px rgba(0,0,0,0.25)",
    };

    useEffect(() => {
    }, []);

    return (
        <div style={containerStyle}>
            <Card style={cardStyle} bodyStyle={{ padding: 28 }}>
                {/* Logo / Avatar */}
                <div style={{ textAlign: "center", marginBottom: 12 }}>
                    <Avatar size={72} icon={<UserOutlined />} style={{ background: token.colorPrimary, marginBottom: 8 }} />
                </div>

                <Title level={3} style={{ textAlign: "center", marginBottom: 6, fontWeight: 700 }}>
                    {t("LOGIN_TITLE")}
                </Title>
                <Text type="secondary" style={{ display: "block", textAlign: "center" }}>
                    {t("LOGIN_SUBTITLE")}
                </Text>

                <LangSelect onChange={() => 1} style={{ width: '100%', marginTop: '12px' }} value={activeLang} />


                {errorMessage && errorMessage !== "" && (
                    <Flex >
                        <Alert style={{ marginTop: 16, width: '100%' }} type="error" showIcon banner message={t(errorMessage)} />
                    </Flex>
                )}

                <Space>

                    {errorMessage == 'BACKEND_ACCOUNT_NOT_CONFIRMED' ? (<div style={{ display: "flex", alignItems: "center", marginTop: '8px', gap: 8 }}>
                        <Button
                            loading={loadingResend}
                            type="link"
                            size="small"
                            icon={<ReloadOutlined />}
                            onClick={onClickResendConfirmation}
                        >
                            {t("RESEND_CONFIRMATION_EMAIL")}
                        </Button>
                    </div>

                    ) : null}
                </Space>

                <Form
                    name="login"
                    layout="vertical"
                    autoComplete="off"
                    requiredMark="optional"
                    style={{ marginTop: 20 }}
                    onFinish={handleSubmit}
                    initialValues={{ remember: true }}
                    form={form}
                >
                    <Form.Item
                        label={t("LABEL_EMAIL")}
                        name="Email"
                        rules={[
                            { required: true, message: t("ERROR_EMAIL_REQUIRED") },
                            { type: "email", message: t("ERROR_EMAIL_INVALID") },
                        ]}
                    >
                        <Input
                            prefix={<MailOutlined />}
                            placeholder={t("PLACEHOLDER_EMAIL")}
                            inputMode="email"
                            allowClear
                        />
                    </Form.Item>

                    <Form.Item
                        label={t("LABEL_PASSWORD", "Şifre")}
                        name="Password"
                        rules={[
                            { required: true, message: t("ERROR_PASSWORD_REQUIRED") },
                        ]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder={t("PLACEHOLDER_PASSWORD")} />
                    </Form.Item>

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, marginTop: -6 }}>
                        <Form.Item name="remember" valuePropName="checked" noStyle>
                            <Checkbox>{t("LOGIN_REMEMBER_ME")}</Checkbox>
                        </Form.Item>
                        <Link onClick={()=>navigate('/forgot-password')}>{t("LOGIN_FORGOT_PASSWORD")}</Link>
                    </div>

                    <Button type="primary" htmlType="submit" size="large" block loading={loading} aria-label={t("BTN_LOGIN")}>
                        {t("BTN_LOGIN", "Giriş yap")}
                    </Button>

                    <Divider plain>{t("WORD_OR")}</Divider>

                    <Text type="secondary" style={{ display: "block", textAlign: "center", marginTop: 16 }}>
                        {t("NO_ACCOUNT")}{" "}
                        <Link onClick={() => navigate("/register")}>{t("BTN_REGISTER")}</Link>
                    </Text>
                </Form>
            </Card>
        </div>
    );
}
